export function getProfileNumberPrefix(gender) {
  const normalized = String(gender || "").trim().toLowerCase();
  if (normalized === "male") return "M";
  if (normalized === "female") return "F";
  return "";
}

export function formatProfileNumberValue(profileNo, gender, fallback = "") {
  const rawValue = String(profileNo ?? "").trim().replace(/^#/, "");
  if (!rawValue) return fallback;
  if (/^[mf]\d+$/i.test(rawValue)) return rawValue.toUpperCase();
  if (!/^\d+$/.test(rawValue)) return rawValue;
  const prefix = getProfileNumberPrefix(gender);
  return prefix ? `${prefix}${rawValue}` : rawValue;
}

export function getProfileNumberDisplay(profile, fallback = "") {
  if (!profile) return fallback;
  return formatProfileNumberValue(
    profile.profile_no_display || profile.profileNoDisplay || profile.profile_no || profile.profileNo,
    profile.gender,
    fallback
  );
}

export function formatProfileNumberBadge(profile, fallback = "—") {
  const value = getProfileNumberDisplay(profile, "");
  return value || fallback;
}
